import * as overrideStages from "./overrideStageKeys";

export default overrideStagesList => {
  const validStages = overrideStagesList.filter(
    x =>
      x.stage.description === overrideStages.COMPLETED ||
      x.stage.description === overrideStages.DISCARD_FAILED
  ).length;

  if (validStages >= 1) {
    return true;
  }

  return false;
};
